export const deepCloneObject = (object) => (JSON.parse(JSON.stringify(object)))
